import React, { useMemo, Fragment } from 'react'
import values from 'ramda/es/values'
import map from 'ramda/es/map'
import pathOr from 'ramda/es/pathOr'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import images from 'static'
import roommateSelectors from 'redux/selectors/RoommateSelectors'
import { roommateFirstName, roommateFullName, padUnknownRoommates } from 'services/helpers'

import { LastMessageDetails } from './LastMessageDetails'
import s from './ConversationItem.module.scss'

const AVATAR_SHIFT = 40

const renderAvatar = (avatar, index) => (
  <div
    key={String(index)}
    style={{ marginLeft: (index ? -AVATAR_SHIFT : 0) - index * 2 }}
  >
    <img aria-hidden="true" alt="" src={avatar || images.defaultAvatar} className={s.avatar} rel='noreferrer' />
  </div>
)

const Content = ({ roommates, sid, memberships }) => {
  const { name, avatars } = useMemo(() => {
    const data = padUnknownRoommates(values(roommates), memberships?.length || 0)

    return ({
      name: data.length === 1
        ? roommateFullName(data[0])
        : map(roommateFirstName, data).join(', '),
      avatars: map(pathOr(' ', ['profile_picture_urls', 'large']), data)
    })
  }, [roommates, memberships])

  return (
    <Fragment>
      {avatars.map(renderAvatar)}
      <LastMessageDetails
        name={name}
        roommates={roommates}
        conversationId={sid}
      />
    </Fragment>
  )
}

const mapStateToProps = createStructuredSelector({
  roommates: roommateSelectors.usersByUserIdSelector
})

export default connect(mapStateToProps)(Content)
